import { render, staticRenderFns } from "./AdditionalGuests.vue?vue&type=template&id=8f3a00a0"
import script from "./AdditionalGuests.vue?vue&type=script&lang=js"
export * from "./AdditionalGuests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports